import React, { useRef } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPlus, FiTrash2, FiImage, FiInfo } = FiIcons;

export default function SponsorManager({ sponsors, onAdd, onRemove, error }) {
  const inputRef = useRef(null);

  return (
    <section className="panel sponsor-panel">
      <div className="section-heading">
        <div className="section-icon"><SafeIcon icon={FiImage} /></div>
        <div>
          <span className="eyebrow">PASUL 01</span>
          <h2>Sponsorii echipei</h2>
        </div>
        <span className="count-pill">{sponsors.length}</span>
      </div>
      <p className="section-description">Adaugă logo-urile o singură dată. Rămân salvate în acest browser pentru următoarele imagini.</p>
      <div className="sponsor-list">
        {sponsors.map(sponsor => (
          <div className="sponsor-item" key={sponsor.id}>
            <div className="sponsor-thumb"><img src={sponsor.image} alt="" /></div>
            <span className="sponsor-name" title={sponsor.name}>{sponsor.name}</span>
            <button className="icon-button remove-button" type="button" onClick={() => onRemove(sponsor.id)} aria-label={`Șterge ${sponsor.name}`} title="Șterge sponsorul">
              <SafeIcon icon={FiTrash2} />
            </button>
          </div>
        ))}
        {!sponsors.length && <div className="empty-sponsors">Niciun sponsor adăugat încă. Începe cu primul logo.</div>}
      </div>
      <input ref={inputRef} className="visually-hidden" type="file" accept="image/png,image/jpeg,image/webp,image/svg+xml" onChange={event => { onAdd(event.target.files?.[0]); event.target.value = ''; }} />
      <button className="add-button" type="button" onClick={() => inputRef.current?.click()}>
        <SafeIcon icon={FiPlus} /> Adaugă un logo
      </button>
      {error && <p className="error-text" role="alert">{error}</p>}
      <p className="hint"><SafeIcon icon={FiInfo} /> PNG cu fundal transparent oferă cel mai bun rezultat.</p>
    </section>
  );
}